module.exports = require('./Rubik')
